import {OrderService} from './OrderService';

export interface Order {
  id?: string;
  services: OrderService[];
}
